module.exports = __webpack_public_path__ + "static/img/banner_blue.014d610e.png";